import { Model } from 'caldera-immutable-model';
import moment from 'moment';

export default class TimelineEvent extends Model {
  getId() { return this.id; } // For backwards compatibility
  get id(): number { return this.get('uid'); }
  get uid(): number { return this.get('uid'); }
  get name(): string { return this.get('name'); }
  get dateTime(): string { return this.get('dateTime'); }
  get location(): string { return this.get('location'); }
  get details(): string { return this.get('details'); }
  get projectId(): string { return this.get('projectId'); }

  timezonelessDateTime(): string {
    // This method is required because we're transitioning the date format stored
    // in the database from "2019-05-15T23:00:00-06:00" to "2019-05-15T23:00:00Z"
    const timeWithTimezone = () => {
      // NOTE: For the events that still use timezones.
      // It would be cool if there was a migration that could be run to convert
      // them all oat once.

      return moment(this.dateTime).utcOffset(0, true).format();
    };
    const timeHasTimezone = () => {
      // String doesn't end in 'Z'
      return this.dateTime.toString().slice(-1) !== 'Z';
    };

    if (timeHasTimezone()) {
      return timeWithTimezone();
    } else {
      return moment.utc(this.dateTime).utcOffset(0, true).format();
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/TimelineEvent.js